import {time_min_h} from "../interfaces/prenotazioni_impostazioni";
import firebase from "firebase";

export enum Time_format {
    ONLY_MINUTES,
    ALL_DATE,
    DAYS_MONTH_YEAR,
    EXPLICIT_MONTH
}

const MONTHS = [
    "GENNAIO",
    "FEBBRAIO",
    "MARZO",
    "APRILE",
    "MAGGIO",
    "GIUGNO",
    "LUGLIO",
    "SETTEMBRE",
    "OTTOBRE",
    "NOVEMBRE",
    "DICEMBRE"
];

export class time_format {

    public static format(date: time_min_h | Date | firebase.firestore.Timestamp, format: Time_format){
        if(date instanceof firebase.firestore.Timestamp)
            date = date.toDate();

        if(format === Time_format.ALL_DATE)
            return this.format_date(date, true)
        else if(format === Time_format.ONLY_MINUTES)
            return this.format_date(date, false)
        else if(format === Time_format.DAYS_MONTH_YEAR){
            if(date instanceof Date){
                return this.format_date_day_month_year(date)
            }
            else throw new Error("invalid parameter")
        }
        else if(format === Time_format.EXPLICIT_MONTH){
            if(date instanceof Date){
                return this.format_long_month(date)
            }
        }
    }

    public static format_date(date: time_min_h | Date | firebase.firestore.Timestamp, long = false): string{
        if(date instanceof firebase.firestore.Timestamp)
            date = date.toDate();

        if(date instanceof Date)
            return long ? this.format_date_long(date) : this.format_date_short(date)
        return this.format_time(date)
    }

    private static format_time(time: time_min_h) {
        return this.format_number(time.ore) + ":" + this.format_number(time.minuti)
    }

    private static format_date_short(date: Date) {
        return this.format_number(date.getHours()) + ":" + this.format_number(date.getMinutes())
    }

    private static format_date_long(date: Date) {
        return this.format_date_short(date) + " " + this.format_date_day_month_year(date)
    }

    public static format_date_day_month_year(date: Date){
        return this.format_number(date.getDate()) + "/" + this.format_number(date.getMonth() + 1) + "/" + date.getFullYear()
    }

    private static format_long_month(date: Date) {
        return date.getDate() + " " + MONTHS[date.getMonth()] + " " + date.getFullYear();

    }

    private static format_number(num: number){
        return num < 9 ? "0" + num : num

    }
}